export const SET_PARAM_AFFIXE2 = 'SET_PARAM_AFFIXE2';
export const SET_PARAMETRE = 'SET_PARAMETRE';

export const PARAMETRES_KEYS = {
  secteurActivite: 'commun/SecteurActivite',
  materielFormat: 'patri/MaterielFormat',
  materielType: 'patri/MaterielType',
  utilisateur: 'commun/Utilisateur',
  civilite: 'commun/Civilite',
  marque: 'commun/Marque',
  remise: 'commun/Remise',
}
